import { postJSON } from 'common/services/api'
import {
  INSTANCES_DELETE_QUERY_KEY,
  INSTANCES_DELETE_URL,
  REVISIONS_QUERY_KEY,
} from './queryConstants'
import { useMutation, useQueryClient } from 'react-query'

type UseInstancesDeleteReturn = {
  deleteEvents?: (values: DeleteEventsPayload) => Promise<unknown>
  isLoadingDeleteEvents?: boolean
}

type DeleteEventsPayload = {
  patternId?: string
  updateOption: string
}

const useInstancesDelete = (): UseInstancesDeleteReturn => {
  const queryClient = useQueryClient()

  // Delete events

  const deleteEventsFunction = async (
    values: DeleteEventsPayload
  ): Promise<unknown> => {
    return postJSON({
      url: `${INSTANCES_DELETE_URL}`,
      method: 'POST',
      json: values,
      isRota: true,
    })
  }

  const {
    mutateAsync: deleteEventsMutation,
    isLoading: isLoadingDeleteEvents,
  } = useMutation<unknown, unknown, DeleteEventsPayload, unknown>(
    [INSTANCES_DELETE_QUERY_KEY],
    deleteEventsFunction,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([REVISIONS_QUERY_KEY])
      },
    }
  )

  const handleDeleteEvents = async (values: DeleteEventsPayload) => {
    try {
      const result = await deleteEventsMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    deleteEvents: handleDeleteEvents,
    isLoadingDeleteEvents,
  }
}

export default useInstancesDelete
